import { useIdleSession } from '@/hooks/useIdleSession'
import { IdleWarningDialog } from '@/components/session/IdleWarningDialog'

/**
 * Mount point for the idle timeout: the hook plus the warning it raises.
 *
 * Both surfaces mount this one component rather than wiring the hook and the
 * dialog separately, so desktop and `/m` cannot drift apart — a timeout that
 * signed phone users out with no warning would be worse than no timeout.
 *
 * It renders inside each router (Layout on desktop, the mobile shell) and not
 * in `AuthProvider`, because the provider sits above the router in both entries
 * and the hook needs both the current route and `useNavigate`. Mounting it
 * under the authenticated shell also means there is no clock on the login
 * screen, which is what keeps a signed-out tab from bouncing itself.
 */
export function IdleSessionGuard() {
  const { state, msRemaining, staySignedIn, signOutNow } = useIdleSession()

  return (
    <IdleWarningDialog
      open={state === 'warning'}
      msRemaining={msRemaining}
      onStaySignedIn={staySignedIn}
      onSignOut={signOutNow}
    />
  )
}
